module.exports = __webpack_public_path__ + "static/media/particles-back-img.e3c69769.png";